/**
 * Adeqo Blog JavaScript
 * Table of Contents and FAQ functionality for Adeqo Blog Post template
 */

document.addEventListener('DOMContentLoaded', function() {
    // Initialize all Adeqo blog features
    initAdeqoTOC();
    initAdeqoFAQ();
    initAdeqoBlogSlider();
    initAdeqoProgressBar();
});

/**
 * Table of Contents Generator
 * Scans for h2 and h3 headings in .adeqo-page-content and builds a clickable TOC
 */
function initAdeqoTOC() {
    const tocList = document.getElementById('adeqo-toc');
    const headings = document.querySelectorAll('.adeqo-page-content h2, .adeqo-page-content h3:not(.adeqo-special)');

    if (tocList && headings.length > 0) {
        headings.forEach((heading, index) => {
            if (!heading.classList.contains('adeqo-toc-header')) {
                // Generate unique ID for the heading
                if (!heading.id) {
                    heading.id = `adeqo-toc-heading-${index + 1}`;
                }

                // Create list item
                const li = document.createElement('li');
                li.textContent = heading.textContent;
                li.style.cursor = 'pointer';

                // Indent h3 headings
                if (heading.tagName.toLowerCase() === 'h3') {
                    li.style.marginLeft = '20px';
                }

                // Add click event for smooth scroll
                li.addEventListener('click', () => {
                    const headerOffset = 160; // Fixed header height
                    const elementPosition = heading.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                });

                tocList.appendChild(li);
            }
        });
    }
}

/**
 * FAQ Accordion
 * Handles expand/collapse of FAQ items with smooth animation
 */
function initAdeqoFAQ() {
    const faqHeadings = document.querySelectorAll('.adeqo-faq-item-heading');

    faqHeadings.forEach((heading) => {
        heading.addEventListener('click', function() {
            const faqBody = heading.nextElementSibling;
            const faqChevron = heading.querySelector('.adeqo-faq-item-chevron');

            if (faqBody && faqBody.classList.contains('adeqo-faq-item-body')) {
                if (faqBody.classList.contains('adeqo-faq-open')) {
                    // Close the FAQ
                    faqBody.classList.remove('adeqo-faq-open');
                    if (faqChevron) {
                        faqChevron.classList.remove('adeqo-rotate-180');
                    }
                } else {
                    // Open the FAQ
                    faqBody.classList.add('adeqo-faq-open');
                    if (faqChevron) {
                        faqChevron.classList.add('adeqo-rotate-180');
                    }
                }
            }
        });
    });
}

/**
 * Adeqo Blog Slider
 * Initialize Swiper for related blogs carousel
 */
function initAdeqoBlogSlider() {
    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
        console.warn('Swiper is not loaded. Adeqo blog slider will not work.');
        return;
    }

    const blogSliders = document.querySelectorAll('.adeqo-blogs-slider');

    blogSliders.forEach((slider) => {
        new Swiper(slider, {
            slidesPerView: 1.4,
            spaceBetween: 24,
            grabCursor: true,
            loop: false,
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                576: {
                    slidesPerView: 2.4,
                },
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    });
}

/**
 * Progress Bar
 * Shows reading progress for article
 */
function initAdeqoProgressBar() {
    const progressBar = document.getElementById('adeqo-progressbar');
    const progressBarMobile = document.getElementById('adeqo-progressbar-mobile');

    if (!progressBar && !progressBarMobile) return;

    const column = document.querySelector('.adeqo-main-article-wrapper');
    if (!column) return;

    // Layout-metingen (getBoundingClientRect) alleen bij load/resize cachen, niet
    // per scroll-event. De scroll-handler leest daarna alleen window.scrollY (geen
    // layout-read) en schrijft de breedte in een rAF -> geen forced reflow.
    let columnTop = 0;
    let columnHeight = 0;
    let ticking = false;

    function measure() {
        const rect = column.getBoundingClientRect();
        columnTop = rect.top + window.scrollY;
        columnHeight = rect.height;
    }

    function update() {
        ticking = false;
        const scrollTop = window.scrollY;
        const viewportHeight = window.innerHeight;
        const columnStart = columnTop;
        const columnEnd = columnTop + columnHeight - viewportHeight;

        let scrollPercent = 0;
        if (columnEnd > columnStart) {
            if (scrollTop >= columnStart && scrollTop <= columnEnd) {
                scrollPercent = ((scrollTop - columnStart) / (columnEnd - columnStart)) * 100;
            } else if (scrollTop > columnEnd) {
                scrollPercent = 100;
            }
        }

        scrollPercent = Math.max(0, Math.min(100, scrollPercent));

        if (progressBar) progressBar.style.width = scrollPercent + '%';
        if (progressBarMobile) progressBarMobile.style.width = scrollPercent + '%';
    }

    function onScroll() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => { measure(); onScroll(); });
    update();
}
